<script setup>
import { storeToRefs } from 'pinia'
import { ref, watch } from 'vue'

const activeSnackbar = ref(false)
const { color, message, timeout, active } = storeToRefs(useSnackbarStore())
const snackbarStore = useSnackbarStore()

watch(active, (value) => {
  activeSnackbar.value = value
})

watch(activeSnackbar, (value) => {
  if (!value) {
    snackbarStore.resetSnackbar()
  }
})
</script>

<template>
  <v-app style="height: 100%; width: 100%">
    <NuxtPage />
    <v-snackbar :timeout="timeout" :color="color" v-model="activeSnackbar" location="top right">
      <div :style="{ whiteSpace: 'pre-line' }">
        {{ message }}
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn elevation="1" text v-bind="attrs" @click="snackbarStore.resetSnackbar()"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<style>
html {
  overflow-y: auto;
}

body {
  font-family: Inter, Roboto, Arial, sans-serif !important;
}

.text-transform-none {
  text-transform: none !important;
}
.v-input__details {
  padding-inline-start: 0px !important;
}
</style>
<style src="./AppVariables.css"></style>
